export default __webpack_public_path__ + "static/media/total-customers-created.0f17e926.png";